/**
 * @desc Set scale or zoom property on {@param target}
 * @param maxHeight - game container max height
 * @param maxWidth - game container max width
 * @param target - that container where need to set zoom or scale property
 * @param returnScaleValue - boolean value for return scale value
 * @param isNeedSetScale - boolean value for set scale
 */
var resizeGame = function (maxHeight, maxWidth, target, isNeedSetScale, returnScaleValue) {
    if (isNeedSetScale === void 0) { isNeedSetScale = false; }
    if (returnScaleValue === void 0) { returnScaleValue = false; }
    var scale;
    var wWidth;
    var wHeight;
    wWidth = window.innerWidth;
    wHeight = window.innerHeight;
    var widthToHeight = maxWidth / maxHeight;
    var wWidthToHeight = wWidth / wHeight;
    if (wWidthToHeight > widthToHeight) {
        wWidth = wHeight * widthToHeight;
        scale = wWidth / maxWidth;
    }
    else {
        wHeight = wWidth / widthToHeight;
        scale = wHeight / maxHeight;
    }
    if (returnScaleValue) {
        return scale;
    }
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || isNeedSetScale) {
        target.style.transform = "scale(".concat(scale, ")");
    }
    else {
        // @ts-ignore
        target.style.zoom = scale;
    }
};

export { resizeGame };
